import { EventSubscription } from './event-subscription.interface';
import { SubscriptionHandler } from './subscription-handler-delegate.type';

/**
 * Delegate description for subscription proxying
 */
export type SubscribeDelegate<TEmission> = (
  handler: SubscriptionHandler<TEmission>,
  error: SubscriptionHandler<Error>) => EventSubscription<TEmission>;
